<template>
  <header>
    <!-- Top Bar -->
    <div class="bg-gradient text-white p-2">
      <div class="md:px-12 max-w-screen-2xl mx-auto flex justify-between items-center">
        <div>
          <span>+234 706 877 7793</span> | <span>info@barkamshelia.com</span>
        </div>
        <div>
          <i class="fa-solid fa-cart-shopping"></i>
        </div>
      </div>
    </div>

    <!-- Main Nav -->
    <div class="bg-black relative">
      <div class="md:px-12 max-w-screen-2xl mx-auto flex justify-between items-center py-4">
        <!-- Logo -->
        <div class="text-white text-3xl">
          <img src="../assets/images/BM_White White.svg" alt="Barka U Mshelia" class="h-8 md:h-12" />
        </div>

        <!-- Desktop Nav -->
        <nav class="hidden lg:flex items-center space-x-6 relative z-50">
          <router-link to="/" class="text-white hover:text-blue transition-all duration-300">Home</router-link>
          
          <!-- About Dropdown for Desktop -->
          <div class="relative group cursor-pointer">
            <div class="text-white px-5 inline-flex items-center transition-all duration-300 hover:text-blue">
              About
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div id="dropdownHover" class="hidden group-hover:block absolute left-0 z-50 bg-black bg-opacity-70 divide-y divide-black shadow-lg w-44">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Bio</router-link>
                </li>
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Achievements</router-link>
                </li>
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Join the Journey</router-link>
                </li>
              </ul>
            </div>
          </div>

          <!-- <router-link to="/speaker" class="text-white hover:text-blue transition-all duration-300">Speaker</router-link>
          <router-link to="/investor" class="text-white hover:text-blue transition-all duration-300">Investor</router-link> -->
          <!-- Leader Dropdown for Desktop -->
          <div class="relative group cursor-pointer">
            <div class="text-white px-5 inline-flex items-center transition-all duration-300 hover:text-blue">
              Leader
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div id="dropdownHover" class="hidden group-hover:block absolute left-0 z-50 bg-black bg-opacity-70 divide-y divide-black shadow-lg w-52">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/mshel-mentorship-club" class="block px-4 py-4 hover:bg-[#202020]">Mshel Mentorship</router-link>
                </li>
                <li>
                  <router-link to="/mshel-realestate-masterclass-club" class="block px-4 py-4 hover:bg-[#202020]">Real Estate Masterclass</router-link>
                </li>
              </ul>
            </div>
          </div>
          <router-link to="/contact" class="text-white hover:text-blue transition-all duration-300">Contact</router-link>

          <router-link to="/mshel-club" class="bg-gradient text-white rounded px-4 py-2 transition-transform hover:scale-110 focus:outline-none">
              Mshel Club
          </router-link>
        </nav>

        <!-- Mobile Menu Button -->
        <div class="lg:hidden">
          <button @click.prevent="toggleMenu" class="text-white focus:outline-none">
            <i v-if="!isMenuOpen" class="fa-solid fa-bars w-10 h-10"></i>
            <i v-else class="fa-solid fa-xmark w-10 h-10"></i>
          </button>
        </div>
      </div>

      <!-- Mobile Nav -->
      <div v-if="isMenuOpen" class="bg-black lg:hidden">
        <nav class="flex flex-col space-y-4 py-4 px-2 text-white">
          <router-link to="/" class="hover:text-blue transition-all duration-300">Home</router-link>
          <!-- About Dropdown for Mobile -->
          <div class="relative">
            <div @click="toggleDropdownAbout" class="text-white hover:text-blue flex items-center transition-all duration-300">
              About
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div v-if="isDropdownOpenAbout" class="bg-black bg-opacity-70 divide-y divide-black shadow-lg w-44">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Bio</router-link>
                </li>
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Achievements</router-link>
                </li>
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Join the Journey</router-link>
                </li>
              </ul>
            </div>
          </div>
          <!-- <router-link to="/speaker" class="hover:text-blue transition-all duration-300">Speaker</router-link>
          <router-link to="/investor" class="hover:text-blue transition-all duration-300">Investor</router-link> -->
          <!-- Leader Dropdown for Mobile -->
          <div class="relative">
            <div @click="toggleDropdownLeader" class="text-white hover:text-blue flex items-center transition-all duration-300">
              Leader
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div v-if="isDropdownOpenLeader" class="bg-black bg-opacity-70 divide-y divide-black shadow-lg w-52">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/mshel-mentorship-club" class="block px-4 py-4 hover:bg-[#202020]">Mshel Mentorship</router-link>
                </li>
                <li>
                  <router-link to="/mshel-realestate-masterclass-club" class="block px-4 py-4 hover:bg-[#202020]">Real Estate Masterclass</router-link>
                </li>
              </ul>
            </div>
          </div>
          <router-link to="/contact" class="hover:text-blue transition-all duration-300">Contact</router-link>

          <router-link to="/mshel-club" class="bg-gradient text-white px-4 py-2 rounded hover:bg-[#d3d3d3] transition-transform hover:scale-110 focus:outline-none">
              Mshel Club
          </router-link>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false,
      isDropdownOpenAbout: false,
      isDropdownOpenLeader: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleDropdownAbout() {
      this.isDropdownOpenAbout = !this.isDropdownOpenAbout;
    },
    toggleDropdownLeader() {
      this.isDropdownOpenLeader = !this.isDropdownOpenLeader;
    },
  },
};
</script>

<style scoped>
#dropdownHover {
  z-index: 1000;
}

.group:hover #dropdownHover {
  display: block;
}

@media (max-width: 1024px) {
  #dropdownHover {
    display: none;
  }
}

</style>
